import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { leaveLink } from '../../../../functions/claim/leaveLink';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { TabPanelComponent } from '../../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../../core/panels/tab-panel/tab.component';
import { AlternateNumbersComponent } from './alternate-numbers.component';
import { CustomFieldsComponent } from './custom-fields.component';
import { HrCustomFieldsComponent } from './hr-custom-fields.component';

@Component({
  selector: 'app-custom-fields-page',
  imports: [
    RouterModule,
    PageHeaderComponent,
    TooltipModule,
    TabPanelComponent,
    TabComponent,
    HrCustomFieldsComponent,
    CustomFieldsComponent,
    AlternateNumbersComponent,
  ],
  template: `
    @if (isAccomodations) {
      <app-page-header label="Custom fields" prototype />
    } @else {
      <app-page-header label="Custom fields" />
    }
    <app-tab-panel>
      @if (authorizeFields) {
        <app-tab label="Fields">
          <ng-template #content>
            <app-custom-fields [canEdit]="authorizeMiscellaneousEdit" />
          </ng-template>
        </app-tab>
      }
      @if ((isDisability || isLeave) && authorizeHR) {
        <app-tab label="HR fields">
          <ng-template #content>
            <app-hr-custom-fields />
          </ng-template>
        </app-tab>
      }
      @if (authorizeAlternateNumbers) {
        <app-tab label="Alternate numbers">
          <ng-template #content>
            <app-alternate-numbers />
          </ng-template>
        </app-tab>
      }
    </app-tab-panel>
  `,
  styles: ``,
})
export class CustomFieldsPageComponent extends BaseComponent implements OnInit {
  isAccomodations = this.view.currentClaim().recordSource === 'R';
  isDisability = this.view.currentClaim().lineOfBusiness === 'DS';
  isLeave = this.view.currentClaim().lineOfBusiness === 'LA';
  isLeaveLink = leaveLink(this.view.currentClaim()?.recordSource);
  authorizeFields = false;
  authorizeHR = false;
  authorizeAlternateNumbers = false;
  authorizeMiscellaneousEdit = false;

  ngOnInit(): void {
    this.view.hideLoading();
    let fieldsAuth = this.session.authorize('Miscellaneous');
    if (fieldsAuth && this.isDisability) {
      fieldsAuth =
        this.view.authorize('RestDsLa') && this.view.authorize('CustDisp');
    }
    this.authorizeFields = fieldsAuth;

    let hrAuth =
      (this.isDisability || this.isLeave) &&
      !this.isLeaveLink &&
      this.session.authorize('EmployeeDetail');
    if (hrAuth && this.isDisability) {
      hrAuth =
        this.view.authorize('RestDsLa') && this.view.authorize('CustDisp');
    }
    this.authorizeHR = hrAuth;
    // AlternateNumbers uses claim-level security (only shown for regular claims, not TAMS/LeaveLink/ADA)
    this.authorizeAlternateNumbers = this.view.authorize('AlternateNumbers');
    this.authorizeMiscellaneousEdit =
      this.session.authorize('MiscellaneousEdit');
  }
}
